















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Staff } from "@/viewmodels/Staff";
import { UserType } from "@/services/LoginService";

@Component({})
export default class extends Vue {
  public collection = app.staffCollection;

  public model: Staff = new Staff({}, this.collection);
  public selectedModel: Staff | null = null;

  public dialog = false;
  public formTitle: string = "Edit Profile";

  public headers = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Email", value: "email" },
    { text: "Phone", value: "phone" },
    { text: "Actions", value: "" }
  ];

  public mounted() {
    this.loadCurrentUser();
  }

  private async loadCurrentUser() {
    const user = app.loginService.currentUser();
    this.model = await this.collection.findByID(user.id);
  }

  public async save() {
    try {
      console.log(this.model);
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  private async onFileSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/staff/upload/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Image uploaded succesfully!"
      });
      app.refreshData();
    }
  }
}
